module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section section-white"
  }, [_c('el-form', {
    attrs: {
      "label-width": "160px"
    },
    model: {
      value: (_vm.form),
      callback: function($$v) {
        _vm.form = $$v
      },
      expression: "form"
    }
  }, [_c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgDialog,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": _vm.closeImgDialog
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动banner",
      "hide-requied-aterisk": "true"
    }
  }, [_c('div', {
    staticClass: "upload-box",
    on: {
      "click": function($event) {
        return _vm.handleImgPicker('banner')
      }
    }
  }, [(_vm.form.banner) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.banner
    }
  }) : _c('i', {
    staticClass: "iconfont icon-camera avatar-uploader-icon"
  })])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "主题分类(由发起者指定)"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择活动分类"
    },
    on: {
      "change": _vm.search
    },
    model: {
      value: (_vm.category_id),
      callback: function($$v) {
        _vm.category_id = $$v
      },
      expression: "category_id"
    }
  }, _vm._l((_vm.category), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.category_name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "addcategory",
    attrs: {
      "label": "新增主题"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "在聚合页中按分类"
    },
    model: {
      value: (_vm.addcategorystr),
      callback: function($$v) {
        _vm.addcategorystr = $$v
      },
      expression: "addcategorystr"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "icon": ""
    },
    on: {
      "click": _vm.handleAddCategory
    }
  }, [_vm._v("主题分类")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动名称"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入活动名称"
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "主办单位"
    }
  }, [_vm._l((_vm.relDistributors), function(item, index) {
    return _c('el-tag', {
      key: item.distributor_id,
      staticClass: "new-tag",
      attrs: {
        "closable": "",
        "disable-transitions": false
      },
      on: {
        "close": function($event) {
          return _vm.handleClose(index)
        }
      }
    }, [_vm._v(" " + _vm._s(item.name) + "\n      ")])
  }), _vm._v(" "), _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "size": "medium"
    },
    on: {
      "click": _vm.addDistributoreAction
    }
  }, [_vm._v("+ 点击搜索店铺 ")])], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "主办单位联系电话"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "主办单位联系电话"
    },
    model: {
      value: (_vm.form.telphone),
      callback: function($$v) {
        _vm.$set(_vm.form, "telphone", $$v)
      },
      expression: "form.telphone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动地址"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "活动地址"
    },
    model: {
      value: (_vm.form.address),
      callback: function($$v) {
        _vm.$set(_vm.form, "address", $$v)
      },
      expression: "form.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "适用人群"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入适用人群"
    },
    model: {
      value: (_vm.form.for_crowd),
      callback: function($$v) {
        _vm.$set(_vm.form, "for_crowd", $$v)
      },
      expression: "form.for_crowd"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动时间"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "range-separator": "至",
      "start-placeholder": "开始时间",
      "end-placeholder": "结束时间",
      "format": "yyyy/MM/dd HH:mm:ss",
      "value-format": "timestamp",
      "default-time": ['00:00:00', '23:59:59']
    },
    model: {
      value: (_vm.activity_date),
      callback: function($$v) {
        _vm.activity_date = $$v
      },
      expression: "activity_date"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "截止报名时间"
    }
  }, [_c('el-col', {
    attrs: {
      "md": 10,
      "lg": 8
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "value-format": "timestamp",
      "default-time": "23:59:59"
    },
    model: {
      value: (_vm.deadline_time),
      callback: function($$v) {
        _vm.deadline_time = $$v
      },
      expression: "deadline_time"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "最大报名人数",
      "rules": _vm.rules.max_num
    }
  }, [_c('el-input-number', {
    attrs: {
      "type": "number",
      "placeholder": "最大报名人数"
    },
    model: {
      value: (_vm.form.max_num),
      callback: function($$v) {
        _vm.$set(_vm.form, "max_num", $$v)
      },
      expression: "form.max_num"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "报名次数",
      "rules": _vm.rules.max_num_time
    }
  }, [_c('el-input-number', {
    attrs: {
      "type": "number",
      "placeholder": "报名次数"
    },
    model: {
      value: (_vm.form.max_num_time),
      callback: function($$v) {
        _vm.$set(_vm.form, "max_num_time", $$v)
      },
      expression: "form.max_num_time"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "支付金额"
    }
  }, [_c('el-input-number', {
    attrs: {
      "type": "number",
      "placeholder": "支付金额"
    },
    model: {
      value: (_vm.form.pay_money),
      callback: function($$v) {
        _vm.$set(_vm.form, "pay_money", $$v)
      },
      expression: "form.pay_money"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "前端显示是否可退款"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    model: {
      value: (_vm.form.show_can_refund),
      callback: function($$v) {
        _vm.$set(_vm.form, "show_can_refund", $$v)
      },
      expression: "form.show_can_refund"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否发放优惠券"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    model: {
      value: (_vm.form.send_card_flag),
      callback: function($$v) {
        _vm.$set(_vm.form, "send_card_flag", $$v)
      },
      expression: "form.send_card_flag"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "showcardsconfig",
    class: _vm.form.send_card_flag ? 'show' : 'hidden'
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("优惠券信息")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addDomain('rule')
      }
    }
  }, [_vm._v("新增优惠券+")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, _vm._l((_vm.form.rule), function(item, index) {
    return _c('div', {
      key: item.key
    }, [_c('el-form-item', {
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "label": '优惠券编码',
        "prop": 'rule.' + index + '.card_id',
        "rules": [{
          required: true,
          message: '优惠券信息'
        } ]
      }
    }, [_c('el-input', {
      attrs: {
        "size": "mini",
        "type": "text",
        "placeholder": "请输入优惠券编码"
      },
      model: {
        value: (item.card_id),
        callback: function($$v) {
          _vm.$set(item, "card_id", $$v)
        },
        expression: "item.card_id"
      }
    })], 1), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeDomain(item, 'rule')
        }
      }
    }, [_vm._v("X")])], 1)
  }), 0)]), _vm._v(" "), _c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading"
    }],
    attrs: {
      "header": "图文详情",
      "shadow": "never"
    }
  }, [(_vm.mode === 'richText') ? [_c('vue-html5-editor', {
    ref: "editor",
    attrs: {
      "content": _vm.form.contents,
      "height": 360
    },
    on: {
      "change": _vm.updateContent
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tpl_item img",
    on: {
      "click": _vm.addImgPreview
    }
  }, [_c('i', {
    staticClass: "iconfont icon-image"
  }), _vm._v("添加图片\n        ")])] : _vm._e(), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.thumbDialog,
      "sc-status": _vm.isGetThumb,
      "isMost": true
    },
    on: {
      "chooseImg": _vm.pickThumb,
      "closeImgDialog": _vm.closeThumbDialog
    }
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer content-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(this.form.status_flag == 0) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v("确定")]) : _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleCancel.apply(null, arguments)
      }
    }
  }, [_vm._v("返回列表")])], 1), _vm._v(" "), _c('DistributorSelect', {
    attrs: {
      "store-visible": _vm.DistributorVisible,
      "is-valid": _vm.isValid,
      "rel-data-ids": _vm.relDistributors,
      "get-status": _vm.DistributorStatus
    },
    on: {
      "chooseStore": _vm.DistributorChooseAction,
      "closeStoreDialog": _vm.closeDialogAction
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c4a622e0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c4a622e0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/storeshop/slefactivity/edit.vue
// module id = 2928
// module chunks = 0